export interface FormOverlap {
  latitude: number
  longitude: number
  siteId: number
  interfaceId: number
  id?: number
}

export interface SiteOverlapDetail {
  id: number
  topRightLatitude: number
  topRightLongitude: number
  bottomLeftLatitude: number
  bottomLeftLongitude: number
  latitude: number
  longitude: number
  imageFileName: string
  imageUrl: string
  rotate: number
  siteId: number
  interfaceId: number
  typeId: number
  iconUrl: string
}

export interface OverlapDetailByFloor {
  id: number
  topRightLatitude: number
  topRightLongitude: number
  bottomLeftLatitude: number
  bottomLeftLongitude: number
  rotate: number
  imageUrl: string
  mobileImageUrl: string
  imageFileName: string
  typeId: number
  floorId: number
  interfaceId: number
}

export enum TypeFloorOverlay {
  OverlayWithAllAnnotations = 1,
  OverlayWithoutPipes = 2,
  None = 0,
}

export interface FormFloorOverlay {
  topRightLatitude: number
  topRightLongitude: number
  bottomLeftLatitude: number
  bottomLeftLongitude: number
  rotate: number
  imageUrl: string
  imageFileName: string
  mobileImageUrl: string
  mobileImageFileName: string
  typeId: number
  floorId: number
  interfaceId: number
  id?: number
}
